import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginacaoNeighborhood } from '../page/neighborhood/paginacaoNeighborhood';
import { Neighborhood } from '../page/neighborhood/neighborhood';

@Injectable({
  providedIn: 'root'
})
export class NeighborhoodService {

  apiURL: string = environment.apiBaseUrl + 'neighborhood';

  constructor(private http: HttpClient) { }

  save(neighborhood: Neighborhood): Observable<Neighborhood> {
    return this.http.post<Neighborhood>(this.apiURL, neighborhood);
  }

  list(page: number, size: number): Observable<PaginacaoNeighborhood> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  update(neighborhood: Neighborhood): Observable<any> {
    return this.http.put<Neighborhood>(`${this.apiURL}/${neighborhood.id}`, neighborhood);
  }

  findNeighborhoodById(id: number): Observable<Neighborhood> {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

  findNeighborhoodByIdActive(id: number): Observable<Neighborhood> {
    return this.http.get<any>(`${this.apiURL}/active/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

  findNeighborhood(page: number, size: number , parametroConsulta: string): Observable<PaginacaoNeighborhood> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}/consulta/${parametroConsulta}?${params.toString()}`);
  }
  
  findNeighborhoodByAll(): Observable<any> {
    return this.http.get<any>(`${this.apiURL}/listar`);
  }

}